<template >
  <tr style="background-color:white">
    
    <!-- Land -->
    <td scope="col" v-if='liveListing.priceInfoHistories?.[0].priceState !== 0'>
      <span>{{ liveListing.marketaccount.country.countryIso }}</span>
    </td>

    <!-- Market Account-->
    <td scope="col" v-if='liveListing.priceInfoHistories?.[0].priceState !== 0'>
      <span class="d-flex">
          <img v-bind:src="'/images/marketicons/' + liveListing.marketaccount.market.id +'.gif'" border="0" width="24" height="24"/>
          <b class="ml-2">{{ liveListing.marketaccount.market.name}}</b>
      </span>
    </td>

    <!-- FU -->
    <td scope="col">
      <span v-if="liveListing.newAsUsed == 1" class="icon icon-cross"></span> <!-- not it! not in gray tr -->
    </td>
    <!-- LSt -->
    <td scope="col">
      <span v-if="!isNegativePriceState()">{{ liveListing.quantity }}</span>
      <span v-else>—</span>
    </td> <!-- TODO: @dommd -->
    
    <!-- Seller -->
    <td scope="col">
      <span v-if="isNegativePriceState()">—</span>
      <span v-else-if='liveListing.priceInfoHistories.length > 0'>
          <span v-if='liveListing.priceInfoHistories[0] && liveListing.priceInfoHistories?.[0].merchantPrice > 0'>
            <p class="mb-0">{{ Number(liveListing.priceInfoHistories[0].merchantPrice).toFixed(2) + ' ' + liveListing.currencySymbol }}</p>
            <p v-if="liveListing.currencyIso != 'EUR'">{{(Number(liveListing.priceInfoHistories[0].merchantPrice)*Number(liveListing.marketaccount.country.currencyToEuro)).toFixed(2) + ' €'}}</p>
          </span>
          <span v-else-if='liveListing.priceInfoHistories[1] && liveListing.priceInfoHistories?.[1].merchantPrice > 0'>
            <p class="mb-0">{{ Number(liveListing.priceInfoHistories[1].merchantPrice).toFixed(2) + ' ' + liveListing.currencySymbol }}</p>
            <p v-if="liveListing.currencyIso != 'EUR'">{{(Number(liveListing.priceInfoHistories[1].merchantPrice)*Number(liveListing.marketaccount.country.currencyToEuro)).toFixed(2) + ' €'}}</p>
          </span>
          <span v-else><p>—</p></span>
      </span>
    </td>

    <!-- New FBA -->
    <td scope="col">
      <span v-if="isNegativePriceState()">—</span>
      <span v-else-if='liveListing.priceInfoHistories.length > 0'>
          <span v-if='liveListing.priceInfoHistories[0] && liveListing.priceInfoHistories?.[0].marketPrice > 0'>
            <p class="mb-0">{{Number(liveListing.priceInfoHistories[0].marketPrice).toFixed(2) + ' ' + liveListing.currencySymbol }}</p>
            <p class="mb-0">{{(Number(liveListing.priceInfoHistories[0].marketPrice) * Number(liveListing.marketaccount.country.currencyToEuro)).toFixed(2) + ' €'}}</p>
          </span>
          <span v-else-if="liveListing.priceInfoHistories[1] && liveListing.priceInfoHistories?.[1].marketPrice > 0">
            <p class="mb-0">{{Number(liveListing.priceInfoHistories[1].marketPrice).toFixed(2) + ' ' + liveListing.currencySymbol }}</p>
            <p class="mb-0">{{(Number(liveListing.priceInfoHistories[1].marketPrice) * Number(liveListing.marketaccount.country.currencyToEuro)).toFixed(2) + ' €'}}</p>
          </span>
          <span v-else>—</span>
      </span>
      <span v-else>—</span>
    </td>

    <!-- min -->
    <td scope="col" v-if='liveListing.sellingPriceMin == "" || isNegativePriceState()'>—</td>
    <td scope="col" v-else>
      <live-listing-price-calc-log-cmp :live-listing="liveListing" v-if="!isNegativePriceState()" />

      <p v-if="liveListing.currencyIso != 'EUR'">{{(Number(liveListing.sellingPriceMin)*Number(liveListing.marketaccount.country.currencyToEuro)).toFixed(2) + ' €' }}</p>
    </td>

    <!-- VK -->
    <td scope="col" v-if="isNegativePriceState()">—</td>
    <td scope="col" v-else>
      <p class="mb-0">{{ Number(liveListing.sellingPrice).toFixed(2) + ' ' + liveListing.currencySymbol }}</p>
      <p v-if="liveListing.currencyIso != 'EUR'">
          {{ (Number(liveListing.marketaccount.country.currencyToEuro) * Number(liveListing.sellingPrice)).toFixed(2) + ' €' }}
      </p>
    </td>
    <!-- Max -->
    <td scope="col" v-if='liveListing.sellingPriceMax == ""  || isNegativePriceState()'>—</td>
    <td scope="col" v-else>
      <p class="mb-0">{{ Number(liveListing.sellingPriceMax).toFixed(2) + ' ' + liveListing.currencySymbol }}</p>
      <p v-if='liveListing.currencyIso != "EUR"'>{{ (Number(liveListing.sellingPriceMax) * Number(liveListing.marketaccount.country.currencyToEuro)).toFixed(2) + ' €' }}</p>
    </td>


    <td>
      <div>
        —
      </div>
    </td>
    <!-- PriceState -->
    <td>
      <div class="row m-auto" v-bind:style='{ color: liveListing.priceStateStyle }'>
            <div id="app">
              <live-listing-price-history-cmp :live-listing="liveListing"/>

            </div>
            <div class="ml-1" v-if='liveListing.priceInfoHistories?.[0].marketPrice > liveListing.sellingPriceMin'> ></div>
      </div>
    </td>
  </tr>
</template>

<script>
import LiveListingPriceHistoryCmp from './LiveListingPriceHistoryCmp.vue'
import LiveListingPriceCalcLogCmp from './LiveListingPriceCalcLogCmp.vue'

export default {
  components : {
    LiveListingPriceHistoryCmp,
    LiveListingPriceCalcLogCmp
  },
  props: {
    liveListing : {
      type: Object,
      requiered: true,
    }
  },
  data(){
    return {
    }
  },
  methods:{
    isNegativePriceState(){
      return (this.liveListing.priceInfoHistories?.[0].priceState == -1 ||
              this.liveListing.priceInfoHistories?.[0].priceState == -3)
    }
  }



}
</script>
